/**
 * Ordine fisso per i marchi della Difesa: sequenza EMAC
 * 1. Cioccolato Militare
 * 2. Esercito 1659
 * 3. Marina Militare
 * 4. Aeronautica Militare
 * 5. Stabilimento Chimico Farmaceutico Militare
 */

const DIFESA_ORDER: Record<string, number> = {
  'cioccolato-militare': 0,
  'esercito-1659': 1,
  'marina-militare': 2,
  'aeronautica-militare': 3,
  'stabilimento-chimico-farmaceutico-militare': 4,
};

/**
 * Ordina i marchi della Difesa secondo la sequenza EMAC.
 * I marchi non riconosciuti vengono messi in fondo.
 * Funziona su qualsiasi array con campo `slug` e opzionalmente `tipo`.
 */
export function sortDifesaBrands<T extends { slug: string; tipo?: string }>(brands: T[]): T[] {
  return [...brands].sort((a, b) => {
    const posA = DIFESA_ORDER[a.slug] ?? 99;
    const posB = DIFESA_ORDER[b.slug] ?? 99;
    return posA - posB;
  });
}

/**
 * Ordina un array misto di marchi: mantiene l'ordine originale per non-difesa,
 * e applica l'ordine EMAC ai marchi difesa nelle loro posizioni relative.
 */
export function sortBrandsWithDifesaOrder<T extends { slug: string; tipo?: string }>(brands: T[]): T[] {
  const difesa: T[] = [];
  const result: (T | null)[] = [...brands];
  const difesaIndices: number[] = [];

  brands.forEach((b, i) => {
    if (b.tipo === 'difesa') {
      difesa.push(b);
      difesaIndices.push(i);
      result[i] = null;
    }
  });

  const sorted = sortDifesaBrands(difesa);
  difesaIndices.forEach((idx, i) => {
    result[idx] = sorted[i];
  });

  return result.filter(Boolean) as T[];
}
